<template>
  <el-form
    :model="modelValue"
    ref="formRef"
    :rules="rules"
    :label-position="labelPosition"
    :label-width="labelWidth"
    :disabled="isDisabled"
  >
    <div v-for="(groupItem, j) in formGroup" :key="groupItem.groupId">
      <div v-if="groupItem.list" :key="j" :class="headerClass">
        {{ headerClass !== 'my-header-none' ? groupItem.groupName : '' }}
      </div>
      <el-row>
        <el-col v-for="(item, index) in groupItem.list" :key="index" :span="formColSpan[item.fieldCode]">
          <el-form-item :prop="item.fieldCode" :label="`${item.fieldName}：`">
            <component
              v-model="modelValue[item.fieldCode]"
              :is="ctList[item.fieldType]"
              :item="item"
              :is-editor="isEditor"
              :is-disabled="isDisabled"
              @my-change="unifySubmit"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>
<script>
import { deepCopy } from '@/utils'
import { defineComponent } from 'vue'
import { formProps, formItemListKey, formManage } from './control-web/index'
import { reactive, ref } from 'vue'
export default defineComponent({
  name: 'custom-assembly',
  props: { ...formProps },
  emits: ['valueChange', 'complete', 'update:modelValue'],
  setup(props, context) {
    // 控件字典
    const ctList = reactive(formItemListKey)
    const formRef = ref(null)
    const { formGroup, formColSpan, formRules, loadComplete, clear, mySubmit, loadData } = formManage(props, context)
    const rules = reactive(formRules)
    const unifySubmit = (e) => {
      context.emit('valueChange', e)
      mySubmit(e)
    }

    const clearForm = () => {
      clear()
      // 清空表单
      formRef.value.resetFields()
    }

    // 提交保存
    const submitFormReturn = (callBack) => {
      if (!formRef.value) {
        return callBack(false)
      }
      formRef.value.validate((valid) => {
        if (valid) {
          let customData = {},
            hasCustom = false
          formGroup.forEach((item) => {
            if (item.list) {
              item.list.forEach((option) => {
                if (option.sysField === 0) {
                  customData[option.fieldCode] = props.modelValue[option.fieldCode]
                  hasCustom = true
                }
              })
            }
          })
          if (hasCustom) {
            let data = deepCopy(props.modelValue)
            data.extendedFields = JSON.stringify(customData)
            context.emit('update:modelValue', data)
          }
        }
        callBack(valid)
      })
    }

    const init = () => {
      if (!loadComplete.value) {
        loadData()
      }
    }

    return {
      ctList,
      formRef,
      formGroup,
      formColSpan,
      rules,
      unifySubmit,
      clearForm,
      submitFormReturn,
      init
    }
  }
})
</script>
